import React from 'react'; 
import { Link } from 'react-router-dom';
import WithConsumer from '../../context/WithConsumer';
import Foot from '../global/Foot';

const News = ({ context }) => {

	let results = '';
	let slug 	= context.newsCat;
		 
    const posts = () => context.posts;
    const post = posts()[0];
            
    if (post) {
	    
	    let pageClass = 'c-page-wrapper c-page c-page-' + post.slug + 'c-news';
		
		if (context.appError){
		
			return null; 
		
		} else if (post.year) {
			
			function handleFilter(evt) {
				evt.preventDefault();
				context.toggleNewsCat(evt.currentTarget.getAttribute('data-slug'));
			}
			
			document.documentElement.classList.remove('state-reverse-header');
			document.documentElement.classList.add('state-minimal-header');
			document.documentElement.classList.remove('scope-reverse');
										
			return (
				<>

					<div className={pageClass}>
						
						<div className="c-page__inner">
						
							<div className="c-page__block c-page__block--space c-page__block--load-effect">
						
								<div className="l-content l-content--fixed-width">
				    				
				    				<div className="l-grid">
				    				
				    					<div className="l-grid__col">
				    					
				    						<h4 className="c-paragraph c-paragraph--xxxlarge" dangerouslySetInnerHTML={{__html:'News'}}></h4>
										
										</div>
										
									</div>
						
								</div>
								
							</div>
														
							<div className="c-page__block c-page__block--space c-page__block--load-effect">
			    
						    	<div className="l-content l-content--fixed-width">
						    		
						    		<div className="l-grid">
						    		
						    			<div className="l-grid__col">
						    				
				    						<div className="c-filters">
				    							
				    							
																	
				    							{post.cat &&
					    							<ul className="c-filters__list">
					    								<li className="c-filters__list__item">
						    								{slug === "view-all" &&
																<a href="#" className="c-filters__list__link state-active" data-slug="view-all" onClick={handleFilter}>View All</a>
															}
															{slug !== "view-all" &&
																<a href="#" className="c-filters__list__link" data-slug="view-all" onClick={handleFilter}>View All</a>
															}
														</li>
														{post.cat.map((item,i) => 
															{
																return (
																	<li className="c-filters__list__item" key={i}>
																		{item.slug === slug &&
																			<a href="#" className="c-filters__list__link state-active" data-slug={item.slug} onClick={handleFilter}>{item.name}</a>
																		}
																		{item.slug !== slug &&
																			<a href="#" className="c-filters__list__link" data-slug={item.slug} onClick={handleFilter}>{item.name}</a>
																		}
																	</li>
																)
															}
														)}
													</ul>
												}
												
											</div>
											
										</div>
						    			
						    		</div>
						    		
						    	</div>
					    		
					    	</div>
					    								
							{post.year.map((year,i) => 
						    	{
							    	let do_year = false;
							    	for (let i=0;i<year.post.length;i++) {
								    	if (slug === 'view-all' || slug === year.post[i].typeslug) {
									    	do_year = true;
									    }	
							    	}
							    	if (do_year === true) {
										return (
											
											<div className="c-page__block c-page__block--l-space c-page__block--load-effect">
						
												<div className="l-content l-content--fixed-width">
								    				
								    				<div className="l-grid">
								    				
								    					<div className="l-grid__col">
								    					
								    						<h2 className="c-paragraph c-paragraph--xlarge c-paragraph--s-space" dangerouslySetInnerHTML={{__html:year.name}}></h2>
															
															{year.post.map((post,i) => 
																{
																	if (slug === 'view-all' || slug === post.typeslug) {
																	return (
																		<Link to={post.url} className="c-news__row">
																			<p className="c-news__row__date" dangerouslySetInnerHTML={{__html:post.date}}></p> 
																			
																			<p className="c-news__row__mobile-cat" dangerouslySetInnerHTML={{__html:post.type}}></p>
																			
																			<div className="c-news__row__text">
																			
																				<div className="c-news__row__heading-wrap">
																					<h2 className="c-news__row__heading" dangerouslySetInnerHTML={{__html:post.heading}}></h2>
																				</div>
																				
																				<p className="c-news__row__cat" dangerouslySetInnerHTML={{__html:post.type}}></p>
																			
																			</div>
																			
																			
																			
																			<p className="c-news__row__read">Read More</p>
																			
																		</Link>
																	)
																	}
																}
															)}
														
														</div>
														
													</div>
										
												</div>
												
											</div>
											
										)
									}
								}
							)}
							
							<Foot></Foot>
																						
						</div>
						
					</div>
					
				</>
			)
						
		} else {
			
			return null;
			
		}

	} else {
		
		return null;
	
	}
};
export default WithConsumer(News);